import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {privacyPolicy} from '#/lib/policies'
import {PolicyDocument} from '#/components/PolicyDocument'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'PrivacyPolicy'>
export const PrivacyPolicyScreen = (_props: Props) => {
  return <PolicyDocument {...privacyPolicy} />
}
